import { Box, FormControl, InputLabel, Typography } from "@mui/material"
import { CheckCircleFilledRounded } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import type { WarehouseShelvingFormValues } from "../../schemas"

import WarehouseShelvingInfo from "./WarehouseShelvingInfo"

import { FormBooleanRadioGroup, FormCheckbox, FormSelect } from "@/components/UiKit"
import { BIN_SIZE_OPTIONS } from "@/constants/warehouse"
import type { WarehouseShelving } from "@/graphql/codegen/graphql"

interface WarehouseShelvingFormProps {
  shelving: WarehouseShelving
}

const WarehouseShelvingForm: FC<WarehouseShelvingFormProps> = ({ shelving }) => {
  const { control, watch, setValue } = useFormContext<WarehouseShelvingFormValues>()
  const isColdStorage = Boolean(watch("coldStorage"))

  const handleColdStorageChange = () => setValue("h3ColdStorage", false)

  return (
    <>
      <Typography
        variant='body1'
        fontWeight={700}
        className='mb-4 flex items-center leading-6 tracking-[0.15px] text-gray-700'
      >
        1. Warehouse Shelving Layout
        <CheckCircleFilledRounded className='ml-2 size-[18px] text-success-500' />
      </Typography>
      <WarehouseShelvingInfo shelving={shelving} className='mb-12' />
      <Typography variant='body1' fontWeight={700} className='mb-6 leading-6 tracking-[0.15px] text-gray-700'>
        2. Shelving Attributes
      </Typography>
      <Box className='flex flex-col gap-y-6'>
        <FormBooleanRadioGroup
          control={control}
          name='coldStorage'
          label='Cold Storage'
          required
          data-testid='cold-storage-radio-group'
          onChange={handleColdStorageChange}
        />
        <FormBooleanRadioGroup
          control={control}
          name='h3ColdStorage'
          label='H3 Storage'
          required={isColdStorage}
          disabled={!isColdStorage}
          data-testid='h3-storage-radio-group'
        />
        <FormSelect
          control={control}
          name='binSize'
          label='Bin Size'
          required
          placeholder='Please Select'
          options={BIN_SIZE_OPTIONS}
          data-testid='bin-size-select'
        />
        <FormBooleanRadioGroup control={control} name='deep' label='Deep' required data-testid='deep-radio-group' />
        <FormControl>
          <InputLabel>Bin Status</InputLabel>
          <FormCheckbox control={control} name='isDoNotUse' label='Do Not Use' data-testid='do-not-use-checkbox' />
        </FormControl>
      </Box>
    </>
  )
}

export default WarehouseShelvingForm
